export class ConstructionSiteImportModel {
  counter: number = 0;
  branchCode: number = 0;
  code: number = 0;
  alterCode: string | null = null;
  name: string = "";
  enterpriseCode: number = 0;
  conceptCode: number = 0;
  swInvoiceMonthly: boolean = false;
  zoneCode: number = 0;
  address: string | null = null;
  phone: string | null = null;
  alterPhone: string | null = null;
  email: string | null = null;
  clientDocument: string = "";
  clientDocument2: string | null = null;
  invoiceAddress: string | null = null;
  invoicePhone: string | null = null;
  invoiceAlterPhone: string | null = null;
  invoiceEmail: string | null = null;
  observation: string | null = null;
  swIcaRetainer: boolean = false;
  sellerDocument: string = "";
  originDepartmentCode: string = "";
  originCityCode: string = "";
  destinityDepartmentCode: string = "";
  destinityCityCode: string = "";
  constructionSiteStateId: number = 0;

  constructor(counter: number,
    branchCode: number,
    code: number,
    alterCode: string | null,
    name: string,
    enterpriseCode: number,
    conceptCode: number,
    swInvoiceMonthly: boolean,
    zoneCode: number,
    address: string | null,
    phone: string | null,
    alterPhone: string | null,
    email: string | null,
    clientDocument: string,
    clientDocument2: string | null,
    invoiceAddress: string | null,
    invoicePhone: string | null,
    invoiceAlterPhone: string | null,
    invoiceEmail: string | null,
    observation: string | null,
    swIcaRetainer: boolean,
    sellerDocument: string,
    originDepartmentCode: string,
    originCityCode: string,
    destinityDepartmentCode: string,
    destinityCityCode: string,
    constructionSiteStateId: number
  ) {
    this.counter = counter;
    this.branchCode = branchCode;
    this.code = code;
    this.alterCode = alterCode;
    this.name = name;
    this.enterpriseCode = enterpriseCode;
    this.conceptCode = conceptCode;
    this.swInvoiceMonthly = swInvoiceMonthly;
    this.zoneCode = zoneCode;
    this.address = address;
    this.phone = phone;
    this.alterPhone = alterPhone;
    this.email = email;
    this.clientDocument = clientDocument;
    this.clientDocument2 = clientDocument2;
    this.invoiceAddress = invoiceAddress;
    this.invoicePhone = invoicePhone;
    this.invoiceAlterPhone = invoiceAlterPhone;
    this.invoiceEmail = invoiceEmail;
    this.observation = observation;
    this.swIcaRetainer = swIcaRetainer;
    this.sellerDocument = sellerDocument;
    this.originDepartmentCode = originDepartmentCode;
    this.originCityCode = originCityCode;
    this.destinityDepartmentCode = destinityDepartmentCode;
    this.destinityCityCode = destinityCityCode;
    this.constructionSiteStateId = constructionSiteStateId;
  }
}